import React from 'react'
import { useGetThreads } from '../../../model/api/assistant/useGetThreads'
import { HistoryItem } from './HistoryItem'
import { useParams } from 'react-router-dom'

interface Props {}

export const HistoryBox: React.FC<Props> = (props) => {
  const { data: threadsResponse, isLoading } = useGetThreads()
  const { threadId: activeThreadId } = useParams<{ threadId?: string }>()

  if (!threadsResponse || isLoading) {
    return <>Loading</>
  }

  return (
    <div className="flex flex-col gap-3">
      {threadsResponse?.data?.data.map((thread) => (
        <HistoryItem thread={thread} active={activeThreadId === thread.threadId} key={thread.id} />
      ))}
    </div>
  )
}
